import angular from 'angular';
import AtmMakesComponent from './atm-makes.component';
import './atm-makes.scss';

let atmMakesModule = angular.module('serviceSettingsAtmMakes', [])

.component('serviceSettingsAtmMakes', AtmMakesComponent)

.name;

export default atmMakesModule;



// WEBPACK FOOTER //
// ./client/app/components/service_settings/atm-makes/index.js